import React, { memo } from 'react'
import { Box, Container, Grid, LinearProgress, Slide } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import { useQuestionProgress } from './QuestionProgress.hooks'

const QuestionProgress = () => {
	const [{ classes, percent, progressText, extraShortcuts }] = useQuestionProgress()

	return (
		<Box className="section-question-progress">
			<Container className="section-question-progress-container">
				<div className={clsx(classes.root, 'question-progress')}>
					<Grid
						className={clsx(classes.container, 'question-progress-container')}
						container
						justify="flex-start"
					>
						<Slide in direction="up">
							<Grid item xs={5} sm={3} className="question-progress-content">
								<Box mb={0.5}>
									<EditableHTML
										extraShortcuts={extraShortcuts}
										className="question-progress-percent"
										html={progressText}
									/>
								</Box>
								<Box mb={2}>
									<LinearProgress
										className="question-progress-bar"
										classes={{ colorPrimary: classes.barColorPrimary }}
										color="primary"
										variant="determinate"
										value={percent}
									/>
								</Box>
							</Grid>
						</Slide>
					</Grid>
				</div>
			</Container>
		</Box>
	)
}

export default memo(QuestionProgress)
